import React from 'react';
import Typical from 'react-typical';
import {
  FaGithubSquare,
  FaLinkedin,
  // FaFacebookSquare,
  FaTwitterSquare,
  // FaInstagramSquare,
} from 'react-icons/fa';
import './Profile.css';
import { Link } from 'react-router-dom';

const Profile = () => {
  return (
    <div id='head' className='profile-container'>
      <div className='profile-parent'>
        <nav id='bg-nav' className=' navbar  navbar-expand-lg sticky-top '>
          <div id='container' className='container-fluid '>
            <a href='#home'>
              <img
                className='logo'
                src='https://i.ibb.co/HgnVwwB/black.jpg'
                alt=''
                style={{ cursor: 'pointer' }}
              />
            </a>
            <button
              className='navbar-toggler'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#navbarSupportedContent'
              aria-controls='navbarSupportedContent'
              aria-expanded='false'
              aria-label='Toggle navigation'
            >
              <span className='navbar-toggler-icon'></span>
            </button>
            <div
              className='collapse navbar-collapse'
              id='navbarSupportedContent'
            >
              <ul className=' navbar-nav me-auto mb-2 mb-lg-0'>
                <li
                  className='nav-item'
                  data-aos='zoom-in'
                  data-aos-duration='2000'
                >
                  <a
                    className='nav-link active'
                    aria-current='page'
                    href='#home'
                  >
                    Home
                  </a>
                </li>
                <li
                  className='nav-item'
                  data-aos='zoom-in'
                  data-aos-duration='2000'
                >
                  <a className='nav-link' href='#skills'>
                    Skills
                  </a>
                </li>
                <li
                  className='nav-item'
                  data-aos='zoom-in'
                  data-aos-duration='2000'
                >
                  <a className='nav-link' href='#portfolio'>
                    Projects
                  </a>
                </li>
                <li
                  className='nav-item'
                  data-aos='zoom-in'
                  data-aos-duration='2000'
                >
                  <a className='nav-link' href='#contact_me'>
                    Contact
                  </a>
                </li>
                <li
                  className='nav-item'
                  data-aos='zoom-in'
                  data-aos-duration='2000'
                >
                  <Link className='nav-link' to='/Blog'>
                    Blog
                  </Link>
                </li>
                <li
                  className='nav-item'
                  data-aos='zoom-in'
                  data-aos-duration='2000'
                >
                  <a
                    className='nav-link'
                    target='blank'
                    href='https://drive.google.com/file/d/13_xHHmMXNk8dA0RN_0QEH8q1Lc8hXgit/view?usp=sharing'
                  >
                    Resume
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className='profile-details'>
          <div className='profile-details-role  col-6'>
            <h6
              data-aos='fade-down-left'
              data-aos-offset='200'
              data-aos-delay='5'
              data-aos-duration='3000'
              data-aos-easing='ease-in-out'
              data-aos-once='false'
              className='subtitle'
            >
              WELCOME TO MY WORLD
            </h6>
            <h3
              data-aos='fade-down-right'
              data-aos-offset='200'
              data-aos-delay='5'
              data-aos-duration='3000'
              data-aos-easing='ease-in-out'
              data-aos-mirror='true'
              data-aos-once='false'
              className='profile-name'
            >
              Hi, I'm <span id='profile-name'>Masud Talukdar</span>
            </h3>
            <span className='text-white'>
              <h4 data-aos='zoom-in' data-aos-offset='200' data-aos-delay='10'>
                <Typical
                  loop={Infinity}
                  steps={[
                    'a Programar',
                    1000,
                    'a Web Developer',
                    1000,
                    'a MERN Stack Developer',
                    1000,
                  ]}
                />
              </h4>
              <span
                data-aos='fade-up'
                data-aos-offset='200'
                data-aos-delay='5'
                data-aos-duration='3000'
                data-aos-easing='ease-in-out'
                data-aos-once='false'
                id='profile-info'
              >
                Knock of building application with <br /> front and back end
                operations.
              </span>
            </span>

            <div className='social-icon'>
              <div className='single-icon'>
                <a target='blank' href='https://github.com/masudtalukdar'>
                  <FaGithubSquare size='3rem' color='whitesmoke' />
                </a>
              </div>
              <div className='single-icon'>
                <a
                  target='blank'
                  href='https://www.linkedin.com/in/masudtalukdar/'
                >
                  <FaLinkedin size='3rem' color='whitesmoke' />
                </a>
              </div>

              <div className='single-icon'>
                <a target='blank' href='https://twitter.com/masud_talukdar7'>
                  <FaTwitterSquare size='3rem' color='whitesmoke' />
                </a>
              </div>
            </div>

            <div
              data-aos='fade-right'
              data-aos-offset='150'
              data-aos-delay='5'
              data-aos-duration='3000'
              className='profile-options'
            >
              <a href='#contact_me'>
                {' '}
                <button className=' text-white btn btn-outline-primary mx-3 mt-3'>
                  HIRE ME
                </button>
              </a>

              <a
                href='/masud_talukdar_resume.pdf'
                download='masud_talukdar_resume.pdf'
              >
                <button
                  data-aos='fade-up'
                  data-aos-offset='100'
                  data-aos-delay='5'
                  data-aos-duration='3000'
                  className='text-white btn btn-outline-danger mt-3'
                >
                  DOWNLOAD RESUME
                </button>
              </a>
            </div>
          </div>
          <div className='image-bg d-flex row col-0'>
            <div
              data-aos='flip-left'
              data-aos-easing='ease-out-cubic'
              data-aos-duration='2000'
              className='image'
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
